import { ScrollView } from "react-native-gesture-handler";
import { View } from "@/components/ui/view";
import { RadioGroup } from "@/components/ui/radio";
import i18n from 'i18n-js';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ModalFrame from '../../components/basic/ModalFrame';
import RadioButton from '../../components/basic/RadioButton';
import * as Speech from 'expo-speech'
import { changeSettings } from "../../stores/mainSlice";

export default function ModalVoices({ showModal, setShowModal }) {
    const dispatch = useDispatch()

    const [voices, setVoices] = useState([])
    const [voiceId, setVoiceId] = useState(useSelector(state => state.settings.voice))

    const selectVoice = (identifier) => {
        setVoiceId(identifier)
        const actVoice = voices.find(voice => voice.identifier == identifier)
        console.log('VOICE', actVoice)
        Speech.speak(i18n.t('modalVoice.sample', { voice: actVoice.name }), actVoice.identifier ? { voice: actVoice.identifier } : {})
    }

    useEffect(() => {
        const loadVoices = (counter) => {
            setTimeout(async () => {
                let availableVoices = await Speech.getAvailableVoicesAsync();
                if (availableVoices.length > 0) {
                    // console.log('VOICES', counter || 0, availableVoices)
                    availableVoices.unshift({ "identifier": null, "language": i18n.t('modalVoice.language'), "name": "Standard", "quality": "Default" })
                    setVoices(availableVoices
                        .filter(voice => voice.language == i18n.t('modalVoice.language'))
                        .map((voice, idx) => ({ ...voice, name: voice.name == voice.identifier ? i18n.t('modalVoice.voice', { idx: idx }) : voice.name })))
                } else {
                    if (!counter || counter < 10) {
                        loadVoices((counter ?? 0) + 1);
                    } else {
                        // console.log('VOICES', counter || 0, availableVoices)
                    }
                }
            }, (counter ?? 1) * 300);
        }
        loadVoices()
    }, [])

    const onClose = (isOk) => {
        setShowModal(false)
        if (isOk) {
            dispatch(changeSettings({ settings: { voice: voices.find(voice => voice.identifier == voiceId) } }))
        }
    }

    return (
        <ModalFrame title='appSettings.speech' text='modalVoice.text' showModal={showModal} onClose={onClose}>
            <View className="h-[200px]">
                <ScrollView scrollIndicatorInsets={{ right: 1 }} className="flex-1 bg-secondary-50 py-3 px-3">
                    <RadioGroup value={voiceId} name='RadioGroup' accessibilityLabel={i18n.t('modalVoice.text')} onChange={idx => { selectVoice(idx) }}>
                        {voices.map(voice => <RadioButton key={voice.identifier} onPress={selectVoice} text={voice.name} raw={true} variant='outline' value={voice.identifier} />)}
                    </RadioGroup>
                </ScrollView>
            </View>
        </ModalFrame>
    );
}
